import { resolveAppLinkOnGate } from '@/core/api/portal'

export type AppLinkOrgDecision =
  | { kind: 'open' }
  | { kind: 'switch-org'; organisationId: string }
  | { kind: 'fail' }

export function decideAppLinkOrg(
  coachingOrgId: string | null,
  me: { organisationId: string; memberships: readonly { organisationId: string }[] },
): AppLinkOrgDecision {
  if (!coachingOrgId) return { kind: 'fail' }
  if (coachingOrgId === me.organisationId) return { kind: 'open' }
  if (me.memberships.some((m) => m.organisationId === coachingOrgId)) {
    return { kind: 'switch-org', organisationId: coachingOrgId }
  }
  return { kind: 'open' }
}

const RESOLVE_ERROR = 'Link ungültig oder abgelaufen.'

export async function resolveAppLink(token: string) {
  try {
    return await resolveAppLinkOnGate(token)
  } catch {
    throw new Error(RESOLVE_ERROR)
  }
}
